// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { getAnalytics, logEvent } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


// Production config
const firebaseConfigProd = {
  apiKey: "AIzaSyAScGzLIWO4wfjZS-R3MZnvOnINK8XMpc8",
  authDomain: "houseupsidedown-bc79d.firebaseapp.com",
  projectId: "houseupsidedown-bc79d",
  storageBucket: "houseupsidedown-bc79d.appspot.com",
  messagingSenderId: "160985945103",
  appId: "1:160985945103:web:910c42f592d64093e2bf7a",
  measurementId: "G-PBX25CXNWW"
};

// Test config
const firebaseConfigTest = {
  apiKey: "AIzaSyAcQ2YYuK4wHOnG0OhdUGTrcDLhniWYcGw",
  authDomain: "hdu-test.firebaseapp.com",
  projectId: "hdu-test",
  storageBucket: "hdu-test.firebasestorage.app",
  messagingSenderId: "1021698660213",
  appId: "1:1021698660213:web:21a744429b0deac4d9e53c"
}


// Initialize Firebase
const app = initializeApp(process.env.REACT_APP_ENV === 'test' ? firebaseConfigTest : firebaseConfigProd);
export const auth = getAuth(app);
export const db = getFirestore(app);
const analytics = getAnalytics(app);

export const logMe = (name, params) => {
  logEvent(analytics, name, params);
}

logMe('boot');

if(process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_LOCAL === "1") {
  connectAuthEmulator(auth, "http://127.0.0.1:9099");
  connectFirestoreEmulator(db, 'localhost', 8080);
}
